import { ITab } from 'components/molecules/tabs';
import { RuleGroup } from 'constants/issues';

export const NOTIFY_OFFICERS_TABS: ITab[] = [
  { id: 'passes', name: 'Step 1: Confirm TEP Devices' },
  { id: 'contacts', name: 'Step 2: Select contact numbers' },
];

export const ISSUES_TABS: ITab[] = [
  { id: RuleGroup.OPEN_RUNWAY, name: 'open runway incidents' },
  { id: RuleGroup.CLOSED_RUNWAY, name: 'closed runway incidents' },
  { id: RuleGroup.TAXIWAY, name: 'taxiway incidents' },
  { id: RuleGroup.DECONFLICT, name: 'deconflict incidents' },
];

export const PAGE_SIZES = [
  { value: 10, label: 'display X entries' },
  { value: 20, label: 'display X entries' },
  { value: 30, label: 'display X entries' },
];
